const focus = {
  mounted(el, binding) {
    el.focus();
    el.style.width = binding.value + 'px'
  }
}

export default focus
